import styled from "styled-components";

const StylesDialogWrapper = styled.div<any>`
  padding: 20px 20px 30px 30px;
  position: relative;

  ${({StylesDialog}) => StylesDialog};
`;

export default StylesDialogWrapper;